import { render } from "./TaxonPicker.vue?vue&type=template&id=6ca1fdd5&scoped=true&ts=true"
import script from "./TaxonPicker.vue?vue&type=script&lang=ts"
export * from "./TaxonPicker.vue?vue&type=script&lang=ts"

import "./TaxonPicker.vue?vue&type=style&index=0&id=6ca1fdd5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca1fdd5"]])

export default __exports__